import {jsx as _jsx} from "react/jsx-runtime";
import {Suspense, useState} from 'react'
import useQueryLoaderNow from '~/hooks/useQueryLoaderNow'

import imageSelectorSearchTabQuery from '../../../__generated__/ImageSelectorSearchTabQuery.graphql'
import {ImageSelectorSearchTab} from './ImageSelectorSearchTab'





export const ImageSelectorSearchTabRoot = (props) => {
  const {editor} = props
  const [searchQuery, setSearchQuery] = useState('')
  const queryToSendToServer = searchQuery.length > 2 ? searchQuery : ''
  const queryRef = useQueryLoaderNow(
    imageSelectorSearchTabQuery,
    {
      fetchOriginal: editor.storage.imageUpload.editorWidth > 500,
      query: queryToSendToServer
    },
    undefined,
    true
  )

  return (
    _jsx(Suspense, { fallback: '', children: 
      queryRef && (
        _jsx(ImageSelectorSearchTab, {
          ...props,
          searchQuery: searchQuery,
          setSearchQuery: setSearchQuery,
          queryRef: queryRef,}
        )
      )
    })
  )
}
export default ImageSelectorSearchTabRoot
